export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      fixed: 'left',
      width: 50,
      slot: 'index',
    },
    {
      key: 'museumname',
      dataIndex: 'museumname',
      title: '名称',
    },
    {
      key: 'level',
      dataIndex: 'level',
      title: '等级',
    },
    {
      key: 'province',
      dataIndex: 'province',
      title: '省份',
    },
    {
      key: 'prescore ',
      dataIndex: 'prescore',
      title: '调整前分值',
    },
    {
      key: 'addedscore',
      dataIndex: 'addedscore',
      title: '最终分值',
    },
    {
      key: 'result',
      dataIndex: 'result',
      title: '成绩',
    },
    {
      key: 'rankingprovince',
      dataIndex: 'rankingprovince',
      title: '同级本省排名',
    },
    {
      key: 'rankingall',
      dataIndex: 'rankingall',
      title: '同级总排名',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '操作',

      width: 100,
      slot: 'operate',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
export const tableData1 = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      fixed: 'left',
      width: 50,
      slot: 'index',
    },
    {
      key: 'museumname',
      dataIndex: 'museumname',
      title: '名称',
    },
    {
      key: 'result',
      dataIndex: 'result',
      title: '成绩',
    },
    {
      key: 'rankingprovince',
      dataIndex: 'rankingprovince',
      title: '同级本省排名',
    },
    {
      key: 'rankingall',
      dataIndex: 'rankingall',
      title: '同级总排名',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '操作',

      width: 100,
      slot: 'operate',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
export const tableData2 = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      fixed: 'left',
      width: 50,
      slot: 'index',
    },
    {
      key: 'label',
      dataIndex: 'label',
      title: '评估指标项',
    },
    {
      key: 'avgscore',
      dataIndex: 'avgscore',
      title: '定性相对平均分',
    },
    {
      key: 'rankingprovince',
      dataIndex: 'rankingprovince',
      title: '加/减分',

      width: 100,
      slot: 'operatecut',
    },
    {
      key: 'rankingall',
      dataIndex: 'rankingall',
      title: '加减分值',

      width: 100,
      slot: 'operatenum',
    }
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
export const tableData3 = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      fixed: 'left',
      width: 50,
      slot: 'index',
    },
    {
      key: 'label',
      dataIndex: 'label',
      title: '评估指标项',
    },
    {
      key: 'avgscore',
      dataIndex: 'avgscore',
      title: '定性相对平均分',
    },
    {
      key: 'rankingprovince',
      dataIndex: 'rankingprovince',
      title: '加/减分',

      width: 100,
      slot: 'operatecut',
    },
    {
      key: 'rankingall',
      dataIndex: 'rankingall',
      title: '加减分值',

      width: 100,
      slot: 'operatenum',
    }
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
export const tableData4 = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: '指标编码',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '指标内容',
      width:'200px'
    },
    {
      key: 'operate2019',
      dataIndex: 'operate2019',
      title: '2019年度',
      slot:'operate2019',
    },
    {
      key: 'operate2020',
      dataIndex: 'operate2020',
      title: '2020年度',
      slot:'operate2020',
    },
    {
      key: 'operate2021',
      dataIndex: 'operate2021',
      title: '2021年度',
      slot:'operate2021',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};

